//@ts-nocheck
import {
  Divider,
  Dropdown,
  Form,
  Grid,
  Text,
  Checkbox,
} from '@wework/dieter-ui'
import React, { useState } from 'react'
import SATextHolder from './SATextHolder'

export default function EditPhysicalSpaceMeetingRoom({
  space,
  setShowLinkeage,
  roomData,
  setRoomData,
}) {
  const [viewQuality, setViewQuality] = useState<any>('Unknown')
  if (!space) {
    return null
  }
  return (
    <>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Text style={{ fontWeight: 'bold', fontSize: 16 }}>Attributes</Text>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
              Room amenities
            </Text>
            <Text size="small" style={{ color: '#777' }}>
              Mark the relevant amenities that are avilable to this rooms.{' '}
            </Text>
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Group grouped>
              <Form.Field>
                <Checkbox label="Phone" />
              </Form.Field>
              <Form.Field>
                <Checkbox label="Whiteboard" />
              </Form.Field>
              <Form.Field>
                <Checkbox label="TV" />
              </Form.Field>
              <Form.Field>
                <Checkbox label="Video conferencing" />
              </Form.Field>
            </Form.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}
